import UserListsComponent from '../../common/UserLists';

import './style.scss';

const UserLists = () => {
    return <div className='user-lists-page'>
        <UserListsComponent />
    </div>;
};

export default UserLists;